import { Grid, Typography } from '@mui/material';
import { formatPersonalNumber } from 'src/shared/functions/formatStringToDate';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MemberAvatar from 'src/modules/member/components/memberAvatar';
import { MemberDetailBirthDate } from 'src/modules/member/components/memberDetailBirthDate';
import { t } from 'i18next';
import { DonorResponse } from '../models/donor';

interface DonorDetailInfoProps {
  donor: DonorResponse;
}

export const DonorDetailInfo = (props: DonorDetailInfoProps) => {
  const { donor } = props;
  const [firstName, lastName] = donor.name ? donor.name.split(' ') : ['', ''];

  const AutogiroDisplay = () => {
    const { firstName: first, lastName: last, payerNr, accountNr, personalIdentityNumber } = donor.autogiroMandate;

    if (!donor.autogiroMandate) return null;

    const accountDisplay = payerNr || accountNr || personalIdentityNumber;

    return (
      <>
        <Typography variant='caption' sx={{ fontWeight: 600, mt: 1.5, display: 'block' }} color='text.secondary'>
          {t('gift:donorDetail.autogiro')}:
        </Typography>

        <Typography variant='body1' sx={{ display: 'flex', alignItems: 'center' }}>
          <span>
            {first} {last} {accountDisplay && ` (${accountDisplay}`}
          </span>
        </Typography>
      </>
    );
  };

  return (
    <>
      <GridWrapper>
        <Grid item xs='auto'>
          <MemberAvatar firstName={firstName ?? ''} lastName={lastName ?? ''} />
        </Grid>
        <Grid item xs>
          <Typography variant='h6' sx={{ fontWeight: 700 }} gutterBottom>{`${donor.name}`}</Typography>
          <MemberDetailBirthDate birthDate={formatPersonalNumber(donor.personalIdentityNumber) ?? ''} />
          <AutogiroDisplay />
        </Grid>
      </GridWrapper>
    </>
  );
};
